import React, {useEffect, useState} from 'react';
import FullPageLoading from "../../../../components/fullPageLoading/fullPageLoading";
import Ajax from "../../../../api/ajax";
import ImageItem from "../../../../components/imageItem/imageItem";
import './style.scss'
import {CaretLeftOutlined} from "@ant-design/icons";
import SwiperCarousel from "../../../../components/swiper";
import {SwiperSlide} from "swiper/react";

function MagzeOffers(props: any) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);


  useEffect(() => {
    getCollection()
  }, []);

  const getCollection = () => {
    setLoading(true)
    new Ajax({
      success: (res) => {
        setLoading(false)
        setItems(res.data.data.posts)
      },
      error: (error) => {
        setLoading(false)
      }
    }).setUrl(`publisher/final-offer/limit=${6}&offset=${0}/`)
      .setMethod('GET')
      .send();
  }


  return (
    <div id="MagzeOffers" className="relative">
      <FullPageLoading show={loading}/>
      <div className="home-section"  style={{background: '#f5f5f5'}}>
        <h2 className="home-title">{'پیشنهاد‌ مگ‌زی'}</h2>
        <SwiperCarousel>
          {items.map((item) =>
            <SwiperSlide className="category-item">
              <div><ImageItem setPost={props.setPost} item={item} setShowLogin={props.setShowLogin} /></div>
            </SwiperSlide>
          )}
        </SwiperCarousel>
        <span
          className="see-more"
          onClick={()=>{
            props.onSearch('پیشنهاد‌ مگ‌زی', 0, 2)
          }}
        >
          بیشتر ببینید <CaretLeftOutlined />
        </span>
      </div>
    </div>
  );
}

export default MagzeOffers;
